

















import { Component, Vue } from 'vue-property-decorator'
import NewsList from '@/components/NewsList.vue'

@Component({
  components: {
    NewsList
  }
})
export default class News extends Vue {}
